import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import httpClient from "../../utils/httpClient";

interface Portfolio {
  portfolio: string;
}

interface PortfolioState {
  isLoading: boolean;
  data: Portfolio[] | null;
  error: string | null;
}

const initialState: PortfolioState = {
  isLoading: true,
  data: [],
  error: null,
};

export const fetchPortfolioListData = createAsyncThunk(
  "CTDBPortfolioListSlice/fetchPortfolioListData",
  async (_, thunkApi) => {
    try {
      const response = await httpClient.get("/db/product/portfolio");
      if (response.status != 200 || response.data.Status !== "success") {
        if (response.data.Status == "error") {
          return thunkApi.rejectWithValue({
            message: response.data.Message,
          });
        } else {
          return thunkApi.rejectWithValue({
            message: "Failed to get portfolio list",
          });
        }
      }
      return response.data;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      console.log("🚀 ~ error:", error);
      return thunkApi.rejectWithValue({
        message: "Failed to get portfolio list",
      });
    }
  }
);

const CTDBPortfolioListSlice = createSlice({
  name: "CTDBPortfolioListSlice",
  initialState,
  reducers: {
    resetState: (state) => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPortfolioListData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.data = null;
      })
      .addCase(
        fetchPortfolioListData.fulfilled,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (state, action: PayloadAction<any>) => {
          if (action.payload.Status == "success") {
            state.isLoading = false;
            state.data = action.payload.Data;
            state.error = null;
          } else if (action.payload.Status == "error") {
            state.isLoading = false;
            state.data = null;
            state.error = action.payload.message;
          }
        }
      )
      .addCase(
        fetchPortfolioListData.rejected,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.data = null;
          state.error = action.payload.message;
        }
      );
  },
});

export const { resetState } = CTDBPortfolioListSlice.actions;

export default CTDBPortfolioListSlice.reducer;
